export default {
  namespaced: true,
  state: { /* Authenticators have state in submodules. */ }
}
